export default __webpack_public_path__ + "static/media/combo_bb.94de0af6.png";